import {
  ActivitiesComponentType,
  ACTIVITIES_COMPONENT_TYPE_ACTIVITY,
} from 'global/constants';
import { ComponentSubActivity } from './component.constants';
import type { InteractiveLessonSectionComponentFragment } from '../lesson-builder.graphql.generated';

export function getMoveComponentAriaLabel(
  type: ActivitiesComponentType,
  direction: 'up' | 'down',
  number?: number
) {
  if (type === ACTIVITIES_COMPONENT_TYPE_ACTIVITY) {
    return `Move question ${number} ${direction}`;
  } else {
    return `Move this component ${direction}`;
  }
}

export function getStyleProperties(
  component: ComponentSubActivity | InteractiveLessonSectionComponentFragment
) {
  return 'properties' in component && 'style' in component.properties
    ? component.properties.style || undefined
    : undefined;
}
